var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 384.143,
    height: 191.828,
    viewBox: "0 0 384.143 191.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8892",
    "data-name": "Path 8892",
    d: "M420.52,140.63a194.86,194.86,0,0,0-24.87-38.14C354.7,54,272,69.12,240.16,94.15s-33.37,59.92-60.68,69-48.54-8.34-84.95,13.66c-24.64,14.89-35,50.28-34,85.71H443.89c.19-2.89.35-5.72.46-8.46a230.31,230.31,0,0,0-23.83-113.43ZM96.59,214.32,92,211.91l-4.59,2.41.88-5.11-3.72-3.62,5.13-.75,2.3-4.65,2.3,4.65,5.13.75-3.72,3.62Zm104.79,10.09L194.76,233,192,222.5l-10.17-3.65,9.09-5.86.33-10.8,8.37,6.83L210,206l-3.91,10.08,6.08,8.93Zm51.2-66.69-.86,6.24-4.43-4.48-6.2,1.1L244,155l-3-5.56,6.22,1,4.37-4.54,1,6.22,5.66,2.76ZM276,253.91l-5-2.64-5,2.64,1-5.59-4.07-4,5.62-.82,2.51-5.08,2.51,5.08,5.62.82-4.07,4ZM345.63,89.62,343,88.24l-2.63,1.38.5-2.93-2.12-2.07,2.94-.43L343,81.53l1.31,2.66,2.94.43-2.12,2.07Zm78,138.53L417,224.66l-6.65,3.49,1.27-7.4-5.38-5.25,7.43-1.08,3.33-6.73,3.33,6.73,7.43,1.08-5.38,5.25Z",
    transform: "translate(-60.464 -70.692)",
    fill: "#f0f0f0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBg);
export default __webpack_public_path__ + "static/media/star-bg.3c791c970eb24125db61721537b7e103.svg";
export { ForwardRef as ReactComponent };